import { render, staticRenderFns } from "./contact-section.vue?vue&type=template&id=2464f160&scoped=true"
import script from "./contact-section.vue?vue&type=script&lang=js"
export * from "./contact-section.vue?vue&type=script&lang=js"
import style0 from "./contact-section.vue?vue&type=style&index=0&id=2464f160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2464f160",
  null
  
)

export default component.exports